import MainPageWrapper from '../../global/components/MainPageWrapper'
import RouteOptimizationCorrector from './RouteOptimizationCorrector'
import AddCompletedInvoice from './AddCompletedInvoice'
import DriveTimesCalculator from './DriveTimesCalculator'
import LocationConversionReverser from './LocationConversionReverser'
import ScheduleChangeImpactTester from './ScheduleChangeImpactTester'
import DaySettingsMaintenance from './DaySettingsMaintenance'

import styles from './styles.module.css'

export default function JmulletTools() {
  return (
    <MainPageWrapper>
      <h1>jmullet tools</h1>
      <div className={styles.toolsHolder}>
        <DaySettingsMaintenance />
        <ScheduleChangeImpactTester />
        <LocationConversionReverser />
        <RouteOptimizationCorrector />
        <AddCompletedInvoice />
        <DriveTimesCalculator />
      </div>
    </MainPageWrapper>
  )
}
